import { Dispatch, ThunkDispatch } from 'store/store';
import { AnyAction, MiddlewareAPI } from '@reduxjs/toolkit';
import State from 'store/State';
import { selectFillsGraphConfiguration } from 'widgets/fillsGraph/store/configuration/selectors';
import ClickstreamService, {
    ClickstreamEventType,
} from 'clickstream/ClickstreamService';
import { isSetConfigActionFor } from 'widgets/store/actions';
import { WidgetType } from 'widgets/WidgetType';
import { FillsGraphConfigAction } from 'widgets/fillsGraph/store/configuration/actions';

export const handleFillsGraphConfigChangeMiddleware = (
    clickstreamService: ClickstreamService
) => {
    return (middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>) =>
        (next: Dispatch<AnyAction>) =>
        (action: AnyAction) => {
            if (
                !action.payload ||
                !isSetConfigActionFor(WidgetType.FILLS_GRAPH, action)
            ) {
                next(action);
                return;
            }

            const fillsGraphKey = (action as FillsGraphConfigAction).payload!
                .widgetKey;

            const prevConfig = selectFillsGraphConfiguration(
                middlewareAPI.getState(),
                fillsGraphKey
            );

            next(action);

            const nextConfig = selectFillsGraphConfiguration(
                middlewareAPI.getState(),
                fillsGraphKey
            );

            if (prevConfig === undefined) return;

            if (prevConfig !== nextConfig) {
                clickstreamService.postEvent(
                    ClickstreamEventType.FILLS_GRAPH_CONFIG_CHANGED,
                    {
                        previousFillsGraph: JSON.stringify(prevConfig),
                        currentFillsGraph: JSON.stringify(nextConfig),
                    }
                );
            }
        };
};
